// @flow
import React from 'react';
import _ from 'lodash';

let data: Object = {};

export const loadShow = (shows: Object = {}) => {
  data = shows;
};

export const dumpShow = (): Object => data;
export const getShow = (key: string, notfound: boolean): boolean => _.get(data, key, notfound);
export const getShowElement = (
  key: string,
  notfound: string
): React.Element<'span'> => (
  // eslint-disable-next-line react/no-danger
  <span dangerouslySetInnerHTML={{ __html: getShow(key, notfound) }} />
);
export { default as ShowProvider } from './ShowProvider';
